
import makerjs from "makerjs";
function B27(model,zoom,Param,fixedParam){
  //w,h,w1,w2
  console.log("Param==",Param[0].param);
  console.log("Param==",Param[1].param);
  console.log("Param==",Param);
    var plate=model.plate,markers=model.markers,myZoom=zoom*1,
    B = Param[0].param,L = Param[1].param,T = Param[2].param, 
      //  plate = model.plate, markers = model.markers,
       markShift = fixedParam.markShift*1, markShiftTwo = fixedParam.markShiftTwo*1,
       markShiftThree = fixedParam.markShiftThree*1, markShiftFour = fixedParam.markShiftFour*1, markHolesOneD = fixedParam.markHolesOneD*1,

       b = B * 1 * myZoom,
       l = L * 1 * myZoom,
       t = T * 1 * myZoom,
        // r = R * 1 * myZoom,
       // x0 = X*1*myZoom,
       // y0 = Y*1*myZoom;
       
       x0 = (b-t)/2, x1 = 0, x2 =(b-t)/2 ,x3 =b-(b-t)/2 ,x4 =b ,x5 =b-(b-t)/2 , 
       y0 = 0, y1 =l/2,y2 =l, y3 =l,y4 =l/2,y5 =0,glassH =l, glassW = b,h=l,w=b;

   if (b !== 0) {
       var TxtB ="B="+ B;
   }  if (l !== 0) {
    var TxtL = "L="+L;
  }    if (t !== 0) {
    var TxtT = "T="+T;
  } 



   var drawAbnormalShapeB27 = {
       paths: {
        "LeftLine1": new makerjs.paths.Line([x0, y0], [x1, y1]),
        "LeftLine2": new makerjs.paths.Line([x1, y1], [x2,y2]),
        "TopLine":new makerjs.paths.Line([x2,y2], [x3,y3]), 
        "RightLine1":new makerjs.paths.Line([x3,y3], [x4,y4]), 
        "RightLine2":new makerjs.paths.Line([x4,y4], [x5,y5]),
        "BottomLine": new makerjs.paths.Line([x5,y5], [x0, y0]),
       }
   };
   var drawAbnormalShapeB27MarkL = {
       paths: {
        "RightLine": new makerjs.paths.Line([x1- markShift, y0], [x1- markShift, y2]),
        "RightShortUpline": new makerjs.paths.Line([x1, y2], [x1- 2 * markShift, y2]),
        "RightShortDnline": new makerjs.paths.Line([x1, y0], [x1- 2 * markShift, y0]),
       }
   };
   var drawAbnormalShapeB27MarkB = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x0, y0- markShift], [x5, y5- markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x5, y5], [x5, y5 - 2 * markShift]),
       }
  
   };
   var drawAbnormalShapeB27MarkT = {
       paths: {
        "BottomLine": new makerjs.paths.Line([x2, y2+ markShift], [x3, y3+ markShift]),
        "BotmShortLfline": new makerjs.paths.Line([x2, y2], [x2, y2 + 2 * markShift]),
        "BotmShortRTline": new makerjs.paths.Line([x3, y3], [x3, y3 + 2 * markShift]),
       }
  
   };
   makerjs.model.addCaption(drawAbnormalShapeB27MarkB, TxtB, [x0, y0 - 2 * markShift], [x5, y5 - 2 * markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB27MarkT, TxtT, [x2, y2+ 2*markShift], [x3, y3+ 2*markShift]);//长度文字
   makerjs.model.addCaption(drawAbnormalShapeB27MarkL, TxtL, [x1-2*markShift, y0], [x1-2*markShift, y2]);//宽度文字
   
  plate={
    models: {
      drawAbnormalShapeB27: drawAbnormalShapeB27,
      }
    };
    markers={
      models: {
        drawAbnormalShapeB27: drawAbnormalShapeB27,
        drawAbnormalShapeB27MarkL: drawAbnormalShapeB27MarkL,
        drawAbnormalShapeB27MarkT: drawAbnormalShapeB27MarkT,
        drawAbnormalShapeB27MarkB:drawAbnormalShapeB27MarkB,
        }
      };
    
   /*****************************************************************************/
   //return { plate, markers, glassW, glassH }
 
    return{w,h,plate, markers}  
};


export default B27;